import { authService } from '../utils/auth';
import { AUTH_ACTIONS } from '../reducers/authReducer';
import { createUser } from './users';
import { BASE_URL } from '../config/api';
import axios from 'axios';

export const setAuthState = (isAuthenticated) => ({
  type: AUTH_ACTIONS.SET_AUTH_STATE,
  payload: isAuthenticated
});

export const setUser = (user) => ({
  type: AUTH_ACTIONS.SET_USER,
  payload: user
});

export const setToken = (token) => ({
  type: AUTH_ACTIONS.SET_TOKEN,
  payload: token
});

export const setError = (error) => ({
  type: AUTH_ACTIONS.SET_ERROR,
  payload: error
});

export const logout = () => ({
  type: AUTH_ACTIONS.LOGOUT
});

export const initializeAuth = () => async (dispatch) => {
  try {
    const user = await authService.getUser();
    if (user && !user.expired) {
      // Store the access token from JumpCloud
      dispatch(setToken(user.access_token));
      
      const userData = {
        name: user.profile.name,
        email: user.profile.email,
        permissions: {}
      };
      
      // Store user in database
      try {
        const data = await dispatch(createUser(userData));
        dispatch(setUser(data));
      } catch (error) {
        // If user already exists, that's fine
        console.log('User might already exist:', error);
      }
      dispatch(setAuthState(true));
      return true;
    }
    dispatch(setAuthState(false));
    return false;
  } catch (error) {
    console.error('Auth initialization error:', error);
    dispatch(setError(error.message));
    return false;
  }
};

export const loginUser = () => async (dispatch) => {
  try {
    await authService.login();
  } catch (error) {
    console.error('Login error:', error);
    dispatch(setError(error.message));
    throw error;
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    await authService.logout();
    dispatch(logout());
  } catch (error) {
    console.error('Logout error:', error);
    dispatch(setError(error.message));
    throw error;
  }
};

export const handleAuthCallback = () => async (dispatch) => {
  try {
    const user = await authService.handleCallback();
    if (user) {
      // Store the access token from JumpCloud
      dispatch(setToken(user.access_token));
      
      const userData = {
        name: user.profile.name,
        email: user.profile.email,
        permissions: []
      };

      // Store user in database
      try {
        const data = await dispatch(createUser(userData));
        dispatch(setUser(data));
      } catch (error) {
        // If user already exists, that's fine
        console.log('User might already exist:', error);
      }

      dispatch(setAuthState(true));
      return user;
    }
    throw new Error('No user data received');
  } catch (error) {
    console.error('Callback error:', error);
    dispatch(setError(error.message));
    throw error;
  }
};
